import useAppTranslation from "@hooks/language/useAppTranslation";
import SEO from "@modules/seo/SEO";
import { Trans } from "react-i18next";
import img1 from "../assets/unlockChampions_1.webp";
import img2 from "../assets/unlockChampions_2.webp";
import img3 from "../assets/unlockChampions_3.webp";
import img4 from "../assets/unlockChampions_4.webp";
import img5 from "../assets/unlockChampions_5.webp";
import HelpCenterContainer from "../components/HelpCenterContainer";
import HelpCenterDiscordLink from "../components/HelpCenterDiscordLink";
import HelpCenterImage from "../components/HelpCenterImage";
import HelpCenterText from "../components/HelpCenterText";
import HelpCenterTitle from "../components/HelpCenterTitle";

const HowToBuyChampions = () => {
  const { t } = useAppTranslation("pages.helpCenter");

  return (
    <>
      <SEO
        title={t("howToBuyChampions.seo.title")}
        description={t("howToBuyChampions.seo.description")}
      />
      <HelpCenterContainer title={t("howToBuyChampions.title")}>
        <HelpCenterText>{t("howToBuyChampions.intro")}</HelpCenterText>

        <HelpCenterTitle>{t("howToBuyChampions.step1.title")}</HelpCenterTitle>

        <HelpCenterText>{t("howToBuyChampions.step1.text")}</HelpCenterText>

        <HelpCenterImage src={img1} />

        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.howToBuyChampions.step1.note">
            Ensuite, cochez la case “show unowned”.
          </Trans>
        </HelpCenterText>

        <HelpCenterImage src={img2} />

        <HelpCenterTitle>{t("howToBuyChampions.step2.title")}</HelpCenterTitle>
        <HelpCenterText>{t("howToBuyChampions.step2.text1")}</HelpCenterText>
        <HelpCenterImage src={img3} />
        <HelpCenterText>{t("howToBuyChampions.step2.text2")}</HelpCenterText>
        <HelpCenterImage src={img4} />
        <HelpCenterImage src={img5} className="md:min-w-[50%]" />

        <HelpCenterTitle>{t("common.conclusion")}</HelpCenterTitle>

        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.howToBuyChampions.conclusion">
            Débloquer des champions est une manière excitante et accessible
            d'améliorer votre expérience sur League of Legends. Si vous
            rencontrez des problèmes ou avez des questions supplémentaires,
            n'hésitez pas à nous contacter via notre <HelpCenterDiscordLink />.
          </Trans>
        </HelpCenterText>
      </HelpCenterContainer>
    </>
  );
};

export default HowToBuyChampions;
